const ShowDetailsLabel = ({ label, value }) => {
    return (
        <div>
            <div>
                <label className="font-semibold text-slate-500">{label?.toUpperCase()}</label>
            </div>
            <div>
                <label className="text-3xl">{value}</label>
            </div>
        </div>
    )
}

export default ShowDetailsLabel;